import {
  Component, computed,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output, signal,
} from '@angular/core';
import { ProductService } from 'src/app/shared-lib/domains/product';
import { AppService } from "../../shared/app.service";
import { CartService } from "../../shared/cart.service";

@Component({
  selector: 'app-general-settings-section',
  templateUrl: './general-settings-section.component.html',
  styleUrls: ['./general-settings-section.component.scss'],
  standalone: false
})
export class GeneralSettingsSectionComponent implements OnInit {
  @Input() settings;
  @Input() printProduct;
  @Output() settingSelectedEvent = new EventEmitter();
  @Output() goToFinishingEvent = new EventEmitter();
  @Output() closeSettingsEvent = new EventEmitter();

  isMobile = input<boolean>(false);
  settingsSectionHeight = input(0);
  settingsConfigTitleHeight = input(0);
  settingsSelectorButtonsHeight = input(0);

  fixedFooterDesktopHeight = signal(0);
  fixedFooterMobileHeight = signal(0);

  scrollHeightSignal = computed(() => {
    const footerHeight = this.isMobile()
      ? this.fixedFooterMobileHeight()
      : this.fixedFooterDesktopHeight();

    // Cálculo base
    const calculated = this.settingsSectionHeight()
      - this.settingsConfigTitleHeight()
      - this.settingsSelectorButtonsHeight()
      - footerHeight;

    return Math.max(0, calculated);
  });

  constructor(private productService: ProductService, private cartService: CartService, public appService: AppService) {
  }

  ngOnInit() {
  }

  settingOptionSelected(event) {
    this.settingSelectedEvent.emit(event);
  }

  changeQty(event) {
    this.printProduct.qty = event.qty;
    this.productService.setPrintProduct(this.printProduct, this.printProduct.product.printingGroup.files);
    this.cartService.refreshCartPrice();
    this.cartService.setCartBindingUses();
  }

  writeQty(event) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    // Chequear si la tecla presionada es un número o una tecla permitida
    if ((event.key < '0' || event.key > '9') && !allowedKeys.includes(event.key)) {
      event.preventDefault();
      return;
    }
    setTimeout(() => {
      let value = event.target.value;
      if (value === '') {
        value = 1;
      } else {
        value = Number(event.target.value);
        if (value === 0 || Number.isNaN(value) || !Number.isInteger(value)) {
          value = 1;
        } else if (value > 9999) {
          value = 9999;
        }
      }
      event.target.value = value;
      this.changeQty({ qty: value });
    }, 0);
  }

  goToFinishing() {
    this.goToFinishingEvent.emit();
  }

  closeSettings() {
    this.closeSettingsEvent.emit();
  }
}
